// extracted by mini-css-extract-plugin
export default {"tooltip":"ProgressionChartBase_tooltip__t504B","download":"ProgressionChartBase_download__A5RZn"};